import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import InlineSVG from 'components/InlineSVG'
import ReactHtmlParser from 'react-html-parser'
import { Link } from 'react-router-dom'

import './employee.css'

class Employee extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showBio: false
    }

    this.onClick = this.onClick.bind(this)
  }

  onClick () {
    const isMobile = window.matchMedia('(max-width: 1100px)').matches

    if (isMobile) {
      this.setState(state => {
        return {
          showBio: !state.showBio
        }
      })
    }
  }

  render () {
    return (
      <div className={classnames({
        'content content--employee': true,
        'content--employee-new': this.props.new,
        [this.props.className]: this.props.className
      })}>
        <div
          className={classnames({
            'image': true,
            'image--hover': this.state.showBio
          })}
          onClick={this.onClick}
        >
          { this.props.new && (
            <img src='https://dummyimage.com/540x600/ffffff/fff.jpg' alt='You?' />
          )}
          { !this.props.new && (
            <div>
              <img src={this.props.image} alt={this.props.name} />
              <div className='hover'>{ReactHtmlParser(this.props.description)}</div>
            </div>
          )}
        </div>
        <footer>
          <div>
            <h3>
              { !this.props.new && this.props.name }
              { this.props.new && 'You?' }
            </h3>
            <p>
              { !this.props.new && this.props.position }
              { this.props.new && (
                <Link to='/contact' className='hoverable-link'>Apply Now —</Link>
              )}
            </p>
          </div>

          { !this.props.new && <Social items={this.props.social} /> }
        </footer>
      </div>
    )
  }
}

const Social = (props) => {
  if (!props.items) {
    return false
  }

  const items = props.items.map((item, idx) => {
    return (
      <li key={idx}>
        <a href={item.url.value} target='_blank' rel='noreferer noopener'>
          <InlineSVG icon={item.type.value} />
        </a>
      </li>
    )
  })

  return (
    <ul className='social-icons'>
      { items }
    </ul>
  )
}

Employee.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.string,
  description: PropTypes.string,
  new: PropTypes.bool,
  social: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
}

export default Employee



// WEBPACK FOOTER //
// ./src/components/Page/Content/Employee/index.js